var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h430v430H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E3E3E3"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m359.824 347.456-11.91 11.91-59.836-59.836 11.91-11.91z",
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "m35.873 23.963-11.91 11.91-59.836-59.836 11.91-11.91z",
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(323.951 323.493)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#913710",
    d: "m386.219 376.135-9.626 9.626c-4.113 4.113-10.783 4.113-14.896 0l-51.264-51.264c-4.113-4.113-4.113-10.783 0-14.896l9.626-9.626c4.113-4.113 10.783-4.113 14.896 0l51.264 51.264c4.113 4.113 4.113 10.783 0 14.896",
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#4AB3FC",
    style: {
      display: "block"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.815 79.718c58.581-56.572 151.933-54.942 208.505 3.639 56.57 58.581 54.941 151.938-3.64 208.509s-151.933 54.942-208.505-3.64c-56.571-58.58-54.942-151.937 3.64-208.508",
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-67.481-68.297c52.738-52.738 139.971-53.62 197.418-9.101a148 148 0 0 0-9.85-10.88c-57.195-57.195-149.933-57.195-207.128 0s-57.195 149.929 0 207.124a148 148 0 0 0 13.985 12.328c-47.127-57.529-48.121-145.775 5.575-199.471",
    className: "secondary",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-89 187.926 14.505)scale(1.00682)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M87.378-134.35c-61.49-61.49-161.2-61.49-222.69 0-61.5 61.5-61.5 161.2 0 222.69 61.49 61.5 161.2 61.5 222.69 0 61.5-61.49 61.5-161.19 0-222.69M79.896 80.858c-57.356 57.356-150.37 57.356-207.726 0s-57.356-150.359 0-207.715c57.356-57.368 150.37-57.368 207.726 0 57.356 57.356 57.356 150.358 0 207.715",
    className: "primary",
    style: {
      display: "block"
    },
    transform: "translate(210 209)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E3E3E3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M-39.732-20.975a33.2 33.2 0 0 1 7.418-11.278 33.1 33.1 0 0 1 13.845-8.313",
    className: "primary",
    style: {
      display: "block"
    },
    transform: "matrix(3.5 0 0 3.5 214.999 215)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "primary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "secondary"
  })), /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "primary",
    style: {
      display: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagSearch);
export default __webpack_public_path__ + "static/media/magSearch.cd69523d5badae2286331cbc636a0b30.svg";
export { ForwardRef as ReactComponent };